import { Skeleton } from "antd";

const IssueTableSkeleton = ({ rows = 4 }) => (
  <div className="issue-table-skeleton">
    <div className="issue-table-skeleton__header">
      <Skeleton.Input active size="small" style={{ width: "18%" }} />
      <Skeleton.Input active size="small" style={{ width: "14%" }} />
      <Skeleton.Input active size="small" style={{ width: "12%" }} />
      <Skeleton.Input active size="small" style={{ width: "10%" }} />
      <Skeleton.Input active size="small" style={{ width: "10%" }} />
      <Skeleton.Input active size="small" style={{ width: "10%" }} />
      <Skeleton.Input active size="small" style={{ width: "14%" }} />
    </div>
    {Array.from({ length: rows }, (_, index) => (
      <div key={index} className="issue-table-skeleton__row">
        <Skeleton
          active
          title={false}
          paragraph={{ rows: 2, width: ["35%", "55%"] }}
        />
      </div>
    ))}
  </div>
);

export default IssueTableSkeleton;
